import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";

interface Options {
    onSuccess?: () => void;
}

export function useDeleteAgentMutation(options?: Options) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (agentId: string) => {
            const res = await apiClient.deleteAgent({
                params: { agentId },
            });
            if (res.status !== 200) {
                throw new Error("Failed to delete agent");
            }
            return res.body;
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: ["agents"] });
            options?.onSuccess?.();
        },
    });
}
